import InfiniteDebouncedAutocomplete from './InfiniteDebouncedAutocomplete';

export type {
  IInfiniteDebounecedAutocompleteProps,
  IInfiniteDebounecedAutocompleteSearchParams,
} from './InfiniteDebouncedAutocomplete.types';

export default InfiniteDebouncedAutocomplete;
